module.exports = __webpack_public_path__ + "static/media/15.Bird Tweet.c5e48a8e.mp3";